// Story 10.1 — Factory de query keys. Aislado del `QueryClient` para que
// pueda testearse sin requerir `@tanstack/react-query`.

export interface ConversationFilters {
  since?: string;
  until?: string;
  flow?: string;
  status?: 'active' | 'expired' | 'completed';
  q?: string;
}

export const queryKeys = {
  bots: () => ['bots'] as const,
  bot: (id: number) => ['bots', id] as const,
  deployments: (botId: number) => ['bots', botId, 'deployments'] as const,
  analytics: (botId: number, since: string | undefined, until: string | undefined) =>
    ['bots', botId, 'analytics', since ?? null, until ?? null] as const,
  conversations: (botId: number) => ['bots', botId, 'conversations'] as const,
  conversationsList: (botId: number, filters: ConversationFilters) =>
    ['bots', botId, 'conversations', 'list', filters] as const,
  conversationDetail: (botId: number, sessionId: number) =>
    ['bots', botId, 'conversations', 'detail', sessionId] as const,
  files: (botId: number) => ['bots', botId, 'files'] as const,
  fileContent: (botId: number, path: string) => ['bots', botId, 'files', 'content', path] as const,
  health: () => ['health'] as const,
  me: () => ['auth', 'me'] as const,
  // Story 16.5 — organizaciones, miembros e invitaciones.
  organizations: () => ['organizations'] as const,
  organization: (id: number) => ['organizations', id] as const,
  organizationMembers: (id: number) => ['organizations', id, 'members'] as const,
  organizationInvitations: (id: number) => ['organizations', id, 'invitations'] as const,
  logs: (filter: { botId?: number; eventName?: string }) => ['logs', filter] as const,
} as const;
